<div [ngClass]="type()" class="flex gap-4 items-center rounded p-4 notification"
  [attr.role]="this.type() === 'error' ? 'alert' : 'status'">
  <ng-content select=".icon"></ng-content>
  <div><ng-content></ng-content></div>
</div>